var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path7, _path8, _path9, _path0, _rect9, _rect0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBankingServices = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4621 24.0711C30.7121 23.9982 30.5113 25.0138 30.3274 25.8461C30.1818 26.5047 29.6617 28.2979 29.5588 28.9612C29.2702 28.9807 28.9817 29.0025 28.6934 29.0266C28.3248 29.0359 27.9314 29.0626 27.561 29.0811C27.9199 28.1354 28.5055 25.5631 28.901 24.5777C29.0329 24.2491 29.1505 24.1863 29.4621 24.0711Z",
    fill: "#D78B79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2773 6.97356C24.375 6.91604 24.4963 6.91604 24.5941 6.97356L36.7274 14.1103C37.0018 14.2717 36.8874 14.6921 36.569 14.6921H12.3024C11.984 14.6921 11.8695 14.2717 12.144 14.1103L24.2773 6.97356Z",
    fill: "#6E83FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3108 12.3472H27.5606",
    stroke: "white",
    strokeWidth: 1.56241,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8418 17.8174H33.6542L34.5917 27.1915H29.9043L30.8418 17.8174Z",
    fill: "#6E83FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0295 17.8174H25.8419L26.7794 27.1915H22.092L23.0295 17.8174Z",
    fill: "#6E83FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.217 17.8174H18.0294L18.9669 27.1915H14.2795L15.217 17.8174Z",
    fill: "#6E83FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.4985,
    y: 26.4087,
    width: 6.24984,
    height: 1.56235,
    rx: 0.234361,
    fill: "#556AE2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.311,
    y: 26.4087,
    width: 6.24984,
    height: 1.56235,
    rx: 0.234361,
    fill: "#556AE2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.123,
    y: 26.4087,
    width: 6.24984,
    height: 1.56235,
    rx: 0.234361,
    fill: "#556AE2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7173,
    y: 27.9731,
    width: 23.4369,
    height: 2.34353,
    rx: 0.312481,
    fill: "#6E83FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7173,
    y: 14.6934,
    width: 23.4369,
    height: 1.56235,
    rx: 0.156241,
    fill: "#556AE2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2795,
    y: 16.2534,
    width: 4.68722,
    height: 1.56241,
    rx: 0.156241,
    fill: "#556AE2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0916,
    y: 16.2534,
    width: 4.68722,
    height: 1.56241,
    rx: 0.156241,
    fill: "#556AE2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 29.9038,
    y: 16.2534,
    width: 4.68722,
    height: 1.56241,
    rx: 0.156241,
    fill: "#556AE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4354 10.1788C26.9703 10.1788 29.0252 8.12408 29.0252 5.58942C29.0252 3.05475 26.9703 1 24.4354 1C21.9006 1 19.8457 3.05475 19.8457 5.58942C19.8457 8.12408 21.9006 10.1788 24.4354 10.1788Z",
    fill: "#00D2A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4359 8.74141C26.1767 8.74141 27.588 7.33023 27.588 5.58945C27.588 3.84868 26.1767 2.4375 24.4359 2.4375C22.695 2.4375 21.2837 3.84868 21.2837 5.58945C21.2837 7.33023 22.695 8.74141 24.4359 8.74141Z",
    fill: "#19E8B7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.87 6.20047C25.87 5.64591 25.4203 5.19478 24.8676 5.19478H24.172C24.0307 5.19478 23.9159 5.07947 23.9159 4.93781C23.9159 4.79616 24.0308 4.68085 24.172 4.68085H25.3976C25.6037 4.68085 25.7707 4.51329 25.7707 4.30649C25.7707 4.09969 25.6037 3.93213 25.3976 3.93213H24.8929V3.65854C24.8929 3.45174 24.7259 3.28418 24.5197 3.28418C24.3136 3.28418 24.1466 3.45174 24.1466 3.65854V3.93342C23.6055 3.9471 23.1694 4.39184 23.1694 4.93786C23.1694 5.49242 23.6191 5.94355 24.1719 5.94355H24.8675C25.0087 5.94355 25.1236 6.05886 25.1236 6.20052C25.1236 6.34217 25.0087 6.45748 24.8675 6.45748H23.642C23.4358 6.45748 23.2688 6.62504 23.2688 6.83184C23.2688 7.03864 23.4358 7.2062 23.642 7.2062H24.1466V7.47974C24.1466 7.68654 24.3136 7.8541 24.5197 7.8541C24.7259 7.8541 24.8929 7.68654 24.8929 7.47974V7.20491C25.4339 7.19123 25.87 6.74649 25.87 6.20047Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2144 22.9373C24.4171 22.9326 24.6176 22.9805 24.7962 23.0763C25.7272 23.5756 25.5187 24.5518 24.827 25.1398C23.9572 25.9201 23.0437 26.6622 22.1561 27.4218C21.6186 27.8817 20.7435 28.4528 21.8426 28.9532C22.1477 29.0921 22.4487 29.2213 22.7454 29.3691C23.2062 29.5987 23.5795 29.8257 24.1152 29.7868C26.4352 29.6181 28.7582 29.4845 31.0793 29.3289C31.6628 29.2899 32.1837 28.8125 32.6495 28.478L34.5514 27.1144C35.0505 26.7575 35.6995 26.1949 36.3537 26.4533C36.773 26.6188 37.0832 27.2599 36.862 27.6849C36.5509 28.284 35.8547 28.6373 35.3419 29.0494C34.5292 29.6391 33.7828 30.2739 32.9492 30.8237C32.4024 31.1457 30.8682 31.6435 30.1992 31.8842L25.3208 33.6483C23.9852 34.1454 23.2705 34.1743 21.8579 34.3512L17.83 34.8662L13.8547 35.3891C12.1012 35.6155 7.84273 37.3852 6.09987 37.1468C6.88737 37.2481 5.31371 37.0356 6.09987 37.1468C5.84377 35.319 7.10125 31.0716 6.92372 29.2236C7.98734 29.1533 9.34811 28.9541 10.4234 28.8514C11.2266 28.7747 13.2335 28.5939 13.929 28.341C14.8339 28.0119 16.2334 26.8714 17.1213 26.3516C18.1405 25.8025 19.2747 25.1654 20.3229 24.689C21.3467 24.2237 23.1848 23.0524 24.2144 22.9373Z",
    fill: "#FFA786"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 26.9463,
    width: 7.41781,
    height: 12.0539,
    rx: 0.927226,
    fill: "#556AE2"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 6.71704,
    y: 27.8369,
    width: 2.45013,
    height: 10.6173,
    rx: 0.816712,
    fill: "#6E83FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBankingServices);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/banking_services.f31d32fc13eb218f0042c340beeaddfa.svg";